{
    "CxiLicenceType_SOLO": "Solo",
    "CxiLicenceType_TEAMS": "Squadre",
    "CxiLicenceType_CXI": "Integrazione CX",
    "CxiLicenceType_NONE": "Nessuno",
    "NAME": "CxiLicenceTypes"
}